import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a0d5434"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed } from 'vue'
import store, { useRtfix, useSite } from '@/store'
import AppLink from '@/components/common/AppLink.vue'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  props: ['row', 'productType', 'isGroup', 'combineSku'],
  setup(__props) {

const props = __props
const router = useRouter()
// combineSku组合商品sku


const supportCombineAutoAddTk = computed(() => store.state.route.supportCombineAutoAddTk)

const jump = (url: any) => {
  window.open(router.resolve(url).href, '_blank')
}

const shopProductSku = computed(() => {
  return supportCombineAutoAddTk.value && props.row?.shopProductSku?.endsWith('-tk') ? props.row?.shopProductSku?.slice(0, -3) : props.row?.shopProductSku
})

const productSku = computed(() => {
  return supportCombineAutoAddTk.value && props.row?.productSku?.endsWith('-tk') ? props.row?.productSku?.slice(0, -3) : props.row?.productSku
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
    class: _normalizeClass(_unref(useSite)())
  }, [
    (__props.row.productType === 3)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(shopProductSku)), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (__props.row?.platformOrderItemId)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (jump(_unref(useRtfix)('ProductInfo', { query: { platformOrderItemId: __props.row.platformOrderItemId, productType: __props.productType, isGroup: __props.isGroup, combineSku: __props.combineSku } }))), ["stop"]))
              }, _toDisplayString(_unref(productSku)), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(productSku)), 1))
        ], 64))
  ], 2))
}
}

})